import {
  SituationTypeEnum,
} from '@shared/models/situations.model';
import {
  Icon,
  getIconAsset,
} from '@types-custom/models/ui/icon-model';
import { IMapIconModel } from '@types-custom/models/ui/map-icons.model';

const iconSizes = {
  [Icon.map_traffic_light]: '24',
  [Icon.map_parking]: '24',
  [Icon.map_pmt]: '24',
  [Icon.map_bus_stop]: '24',
  [Icon.dot]: '14',
  [Icon.map_accident]: '24',
  [Icon.sensor_OD]: '24',
  [Icon.camera_OD_map]: '48',
  [Icon.parking_state_green_line]: '24',
  [Icon.parking_state_blue_line]: '24',
  [Icon.map_cluster_parking]: '24',
  [Icon.layer_aforo]: '24',
  [Icon.camera_lpr_map]: '120',
  [Icon.panic_button]: '100',
  [Icon.camera_map_blue]: '120',
  [Icon.camera_map_green]: '120',
  [Icon.camera_map_red]: '120',
  [Icon.layer_garbage]: '24',
  [Icon.garbage_full]: '100',
  [Icon.garbage_middle]: '100',
  [Icon.garbage_empty]: '100',
}

const mappedIcons: Icon[] = [
  Icon.map_agents_police,
  Icon.map_agents_transit,
  Icon.map_traffic_light,
  Icon.camera_lpr_map,
  Icon.camera_lpr,
  Icon.map_parking,
  Icon.layer_co2,
  Icon.layer_luminary,
  Icon.layer_luminary_on,
  Icon.layer_luminary_off,
  Icon.layer_luminary_no_signal,
  Icon.layer_garbage,
  Icon.layer_aforo,
  Icon.pointer_map,
  Icon.camera,
  Icon.layer_cameras,
  Icon.in_complaints,
  Icon.map_incident_purple,
  Icon.map_incident_green,
  Icon.map_event_purple,
  Icon.map_event_green,
  Icon.in_conciliated,
  Icon.in_crane,
  Icon.in_inmobilizations,
  Icon.in_road,
  Icon.in_schedule,
  Icon.in_signal,
  Icon.in_traffic,
  Icon.map_pmt,
  Icon.map_bus_stop,
  Icon.dot,
  Icon.map_zones_white,
  Icon.map_zones_orange,
  Icon.map_zones_blue,
  Icon.map_zones_yellow,
  Icon.map_accident,
  Icon.map_pmv,
  Icon.layer_runt,
  Icon.sensor_OD,
  Icon.camera_OD_map,
  Icon.layer_scooter,
  Icon.layer_bicycle,
  Icon.layer_stop_bus,
  Icon.parking_state_green_line,
  Icon.parking_state_blue_line,
  Icon.parking_state_free,
  Icon.parking_state_occupied,
  Icon.parking_state_unknown,
  Icon.parking_state_loading_free,
  Icon.parking_state_underground,
  Icon.parking_state_loading_occupied,
  Icon.parking_state_loading_unknown,
  Icon.map_cluster_parking,
  Icon.StationPoint,
  Icon.StationIconMap,
  Icon.StationIconMapGreen,
  Icon.MiniStationMap,
  Icon.PMR_Ocupado,
  Icon.PMR_Indefinido,
  Icon.PMR_Disponible,
  Icon.panic_button,
  Icon.camera_map_blue,
  Icon.camera_map_green,
  Icon.camera_map_red,
  Icon.garbage_full,
  Icon.garbage_middle,
  Icon.garbage_empty,
]

export const mapIcons: IMapIconModel[] = mappedIcons.map(i => {
  const icon = {
    id: i,
    path: getIconAsset(i),
  }
  if (iconSizes[i])
    Object.assign(icon, { size: iconSizes[i] });
  return icon;
});

export const iconClassSituationsMap: { [key: string]: Icon } = {
  [SituationTypeEnum.incidente_abierto]: Icon.map_incident_green,
  [SituationTypeEnum.incidente_cerrado]: Icon.map_incident_purple,
  [SituationTypeEnum.incidente_programado]: Icon.map_incident_green,
  [SituationTypeEnum.evento_abierto]: Icon.map_event_green,
  [SituationTypeEnum.evento_cerrado]: Icon.map_event_purple,
  [SituationTypeEnum.evento_programado]: Icon.map_event_green,
};
